"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMESHEET_MEMBER_STATUS = exports.TIMESHEET_STATUS = void 0;
exports.TIMESHEET_STATUS = {
    TO_DO: "TO_DO",
    IN_PROGRESS: "IN_PROGRESS",
    APPROVED: "APPROVED",
    LOCKED: "LOCKED",
    UPDATED: "UPDATED",
};
exports.TIMESHEET_MEMBER_STATUS = {
    TBC: "TBC",
    STARTED: "STARTED",
    LATE: "LATE",
    FINISHED: "FINISHED",
    SUBMITTED: "SUBMITTED",
    REJECTED: "REJECTED",
    APPROVED: "APPROVED",
    UPDATED: "UPDATED",
};
